import * as React from "react";
import "./DropdownSelect.css";

interface Props {
    onChange: (value: any) => void;
    defaultText: string;
    optionsList: { id: number; name: string }[];
    name: string;
    readOnly: boolean;
}

interface State {
    defaultSelectText: string;
    showOptionList: boolean;
    optionsList: { id: number; name: string }[];
}
class DropdownSelect extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            defaultSelectText: "",
            showOptionList: false,
            //optionsList: [],
            optionsList: this.props.optionsList,
        };
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.defaultText !== this.props.defaultText) {
            this.setState({
                defaultSelectText: this.props.defaultText,
            });
        }
    }

    componentDidMount() {
        // Add Event Listner to handle the click that happens outside
        // the Custom Select Container
        document.addEventListener("mousedown", this.handleClickOutside);
        this.setState({
            defaultSelectText: this.props.defaultText,
        });
    }

    componentWillUnmount() {
        // Remove the event listner on component unmounting
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    // This method handles the click that happens outside the
    // select text and list area
    handleClickOutside = (e: any) => {
        if (
            !e.target.classList.contains("custom-select-option") &&
            !e.target.classList.contains("selected-text")
        ) {
            this.setState({
                showOptionList: false,
            });
        }
    };

    // This method handles the display of option list
    handleListDisplay = () => {
        if (!this.props.readOnly) {
            this.setState((prevState) => {
                return {
                    showOptionList: !prevState.showOptionList,
                };
            });
        }
    };

    // This method handles the setting of name in select text area
    // and list display on selection
    handleOptionClick = (e: any) => {
        if (!this.props.readOnly) {
            this.setState({
                defaultSelectText: e.target.getAttribute("data-name"),
                showOptionList: false,
            });
            this.props.onChange(e.target.getAttribute("data-name"));
        }
    };

    handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!this.props.readOnly) {
            const inputValue = e.target.value;
            this.setState({
                defaultSelectText: inputValue,
                optionsList: this.props.optionsList.filter((option) =>
                    option.name.toLowerCase().includes(inputValue.toLowerCase())
                ),
            });
            this.props.onChange(inputValue);
        }
    };

    render() {
        const { optionsList } = this.props;
        const { showOptionList, defaultSelectText } = this.state;
        return (
            <div className="custom-select-container">
                <input
                    name={this.props.name}
                    className={!this.props.readOnly ? (showOptionList ? "selected-text active" : "selected-text") : "selected-text-inactive"}
                    onClick={this.handleListDisplay}
                    onChange={this.handleInputChange}
                    value={defaultSelectText}
                    role="presentation"
                    readOnly={this.props.readOnly}
                ></input>
                <div className="selected-text-arrow"></div>
                {showOptionList && (
                    <ul className="select-options">
                        {optionsList.map((option) => {
                            return (
                                <li
                                    className="custom-select-option"
                                    data-name={option.name}
                                    key={option.id}
                                    onClick={this.handleOptionClick}
                                >
                                    {option.name}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        );
    }
}

export default DropdownSelect;



// WEBPACK FOOTER //
// ./ClientApp/components/common/DropdownSelect.tsx